// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PremiumInformationStage__root--CIlHz {
    text-align: left;
}

.PremiumInformationStage__imageWrapper--puPWw {
    width: 100%;
    height: 66px;
    position: relative;
}

@media screen and (min-width: 1024px) {

.PremiumInformationStage__imageWrapper--puPWw {
        height: 116px
}
    }

.PremiumInformationStage__image--sxy9N {
    width: 100%;
    height: auto;
    position: absolute;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    z-index: 1;
    mix-blend-mode: screen;
}

@media screen and (min-width: 1024px) {

.PremiumInformationStage__image--sxy9N {
        height: 362px
}
    }

.PremiumInformationStage__plans--usaPU {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

@media screen and (min-width: 1024px) {

.PremiumInformationStage__plans--usaPU {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px
}
    }

.PremiumInformationStage__regularPlan--Kp2q_ {
    border-radius: 6px;
    border: 1px solid var(--dark-secondary-new-color);
    background: radial-gradient(61.51% 70.26% at 100% 0.64%, #94A5CD 0%, rgba(148, 165, 205, 0.00) 100%);
    padding: 16px;
}

.PremiumInformationStage__premiumPlan--ETmoX {
    border-radius: 6px;
    border: 1px solid var(--dark-secondary-new-color);
    background: radial-gradient(62.31% 71.17% at 100.65% 0%, #FFD370 0%, rgba(255, 211, 112, 0.00) 100%);
    padding: 16px;
}

.PremiumInformationStage__title--P6IjJ {
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    margin-bottom: 16px;
}

.PremiumInformationStage__features--oiUBv {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.PremiumInformationStage__feature--AOVGY {
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.21);
    -webkit-backdrop-filter: blur(80px);
            backdrop-filter: blur(80px);
    padding: 8px;
    display: grid;
    grid-template-columns: 24px auto;
    grid-gap: 16px;
    align-items: center;
}

@media screen and (min-width: 1024px) {

.PremiumInformationStage__feature--AOVGY {
        padding: 16px
}
    }

.PremiumInformationStage__description--L0qq1 {
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/PremiumInformationStage/PremiumInformationStage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AAKtB;;AAHI;;AALJ;QAMQ;AAER;IADI;;AAGJ;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;IACvB,QAAQ;IACR,OAAO;IACP,2BAA2B;IAC3B,UAAU;IACV,sBAAsB;AAK1B;;AAHI;;AAZJ;QAaQ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AAOZ;;AALI;;AALJ;QAMQ,aAAa;QACb,8BAA8B;QAC9B;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,iDAAiD;IACjD,oGAAoG;IACpG,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,iDAAiD;IACjD,oGAAoG;IACpG,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,mCAA2B;YAA3B,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,cAAc;IACd,mBAAmB;AAKvB;;AAHI;;AAVJ;QAWQ;AAER;IADI;;AAGJ;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".root {\n    text-align: left;\n}\n\n.imageWrapper {\n    width: 100%;\n    height: 66px;\n    position: relative;\n\n    @media (--large) {\n        height: 116px;\n    }\n}\n\n.image {\n    width: 100%;\n    height: auto;\n    position: absolute;\n    object-fit: contain;\n    object-position: center;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n    z-index: 1;\n    mix-blend-mode: screen;\n\n    @media (--large) {\n        height: 362px;\n    }\n}\n\n.plans {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    @media (--large) {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        grid-gap: 20px;\n    }\n}\n\n.regularPlan {\n    border-radius: 6px;\n    border: 1px solid var(--dark-secondary-new-color);\n    background: radial-gradient(61.51% 70.26% at 100% 0.64%, #94A5CD 0%, rgba(148, 165, 205, 0.00) 100%);\n    padding: 16px;\n}\n\n.premiumPlan {\n    border-radius: 6px;\n    border: 1px solid var(--dark-secondary-new-color);\n    background: radial-gradient(62.31% 71.17% at 100.65% 0%, #FFD370 0%, rgba(255, 211, 112, 0.00) 100%);\n    padding: 16px;\n}\n\n.title {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: 0.6px;\n    text-transform: uppercase;\n    margin-bottom: 16px;\n}\n\n.features {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.feature {\n    border-radius: 6px;\n    background: rgba(0, 0, 0, 0.21);\n    backdrop-filter: blur(80px);\n    padding: 8px;\n    display: grid;\n    grid-template-columns: 24px auto;\n    grid-gap: 16px;\n    align-items: center;\n\n    @media (--large) {\n        padding: 16px;\n    }\n}\n\n.description {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PremiumInformationStage__root--CIlHz`,
	"imageWrapper": `PremiumInformationStage__imageWrapper--puPWw`,
	"image": `PremiumInformationStage__image--sxy9N`,
	"plans": `PremiumInformationStage__plans--usaPU`,
	"regularPlan": `PremiumInformationStage__regularPlan--Kp2q_`,
	"premiumPlan": `PremiumInformationStage__premiumPlan--ETmoX`,
	"title": `PremiumInformationStage__title--P6IjJ`,
	"features": `PremiumInformationStage__features--oiUBv`,
	"feature": `PremiumInformationStage__feature--AOVGY`,
	"description": `PremiumInformationStage__description--L0qq1`
};
export default ___CSS_LOADER_EXPORT___;
